import { useIsAdmin, useIsSuperadmin } from '@atlas-frontend/sdk';

export const useHasPermissionToEdit = (user: {
  isAdmin: boolean;
  isSuperadmin: boolean;
}) => {
  const isAdmin = useIsAdmin();
  const isSuperadmin = useIsSuperadmin();

  return isSuperadmin || (isAdmin && !user.isAdmin && !user.isSuperadmin);
};
